import { render, staticRenderFns } from "./ShowRecentOrders.vue?vue&type=template&id=f99681ea"
import script from "./ShowRecentOrders.vue?vue&type=script&lang=js"
export * from "./ShowRecentOrders.vue?vue&type=script&lang=js"
import style0 from "./ShowRecentOrders.vue?vue&type=style&index=0&id=f99681ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports